import { createFileRoute } from '@tanstack/react-router';

import { ExploreAiPage } from '@/pages/explore-ai/explore-ai-page';

/**
 * `/explore-ai` — the in-app AI feature showcase.  Reachable by everyone
 * (including Free) so they can see what AI unlocks; the page marks each tier
 * available / upgrade-to-unlock for the current plan.
 */
export const Route = createFileRoute('/explore-ai')({ component: ExploreAiPage });
